import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Alert,
} from '@mui/material';
import { Visibility } from '@mui/icons-material';

import PermissionsPreviewTable from '@/components/PermissionsPreviewTable/PermissionsPreviewTable';
import DefaultRoleBadge from '@/components/DefaultRoleBadge/DefaultRoleBadge';
import RoleCustomPaymentTypeAccessSummary from '@/components/RoleCustomPaymentTypeAccessSummary/RoleCustomPaymentTypeAccessSummary';

const RolePreviewDialog = ({ open, onClose, role }) => {
  if (!role) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Visibility color='primary' />
          Role Permissions Preview: {role.name}
          <DefaultRoleBadge role={role} />
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <Alert severity='info' sx={{ mb: 3 }}>
            This preview shows all permissions granted by the &quot;{role.name}
            &quot; role.
          </Alert>

          <Box sx={{ mb: 3 }}>
            <RoleCustomPaymentTypeAccessSummary role={role} />
          </Box>

          <PermissionsPreviewTable
            facilityPermissions={role.facility_permissions}
            organizationPermissions={role.organization_permissions}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RolePreviewDialog;
